<template>
    <div id="data_sources" class="row data-source-wrap mt-md-5">
        <div class="col data-sources-list">
            <div v-if="data_sources !== 0 && data_source.is_active !== -1" v-for="data_source in data_sources" :class="{ 'inactive' : data_source.is_active == -1 }" class="data-source row row-cols-3 align-items-center my-3">
                <div class="data-source-name col"><span><img :src="$store.state.app_url+'/images/data_sources/' + data_source.abbreviation + '.png'">{{ data_source.name }}</span></div>
                <div v-if="data_source.is_active == -1" class="data-source-accounts col">Coming Soon</div>
                <div v-else class="data-source-accounts col"><span class="account-counter text-center">{{ data_source.count }}</span> Account(s) connected</div>
                <div v-if="data_source.is_active != -1" class="data-source-actions col">
                    <button v-if="getUserPermissions().create_connections" @click="connect(data_source.data_source_id, $event)" class="btn btn-secondary pull-right main-button my-2 py-2">+ CONNECT ACCOUNT</button>
                    <span v-if="data_source.count != 0" class="d-inline-block mr-3 pull-right button-wrap">
                        <button @click="view(data_source.data_source_id, $event)" :class=" { 'hidden': data_source.data_source_id == $route.params.id }" class="btn btn-success reverse pull-right btn-size view-button view my-2 py-2" :disabled="!data_source.count">VIEW</button>
                        <button @click="hide(data_source.data_source_id, $event)" :class=" { 'hidden': data_source.data_source_id != $route.params.id }" class="btn btn-success reverse pull-right btn-size view-button mask my-2 py-2">HIDE</button>
                    </span>
                </div>
                <div class="w-100"></div>
                <div class="col  account-details text-left" :style="data_source.data_source_id == $route.params.id && data_source.is_active > -1 ? '' : 'display:none'">
                    <hr style="border-top-color: #eee">
                    <div v-for="connection in data_source.connections" class="account" :data_source_id="data_source.data_source_id" :user_id="user_id" :connection_id="connection.id" :owner_id="data_source.owner_id">
                        <div class="flex-wrap account-wrap view">
                            <div class="account-name">{{connection.connection_name}}</div>
                            <span v-if="getUserPermissions().edit_connections" @click="accountEdit($event)" class="edit-name"><img class="pencil-icon" :src="$store.state.app_url+'/images/data_sources/button_icons/pencil.svg'"></span>
                        </div>
                        <div class="flex-wrap account-wrap edit hidden">
                            <input v-model="connection.connection_name" />
                            <span @click="accountView($event)" class="edit-name"><img class="check-icon" :src="$store.state.app_url+'/images/data_sources/button_icons/check.svg'"></span>
                        </div>
                        <span class="flex-wrap">
                            <span v-if="getUserPermissions().delete_connections" @click="accountRemove($event)" class="remove"><img class="trash-icon" :src="$store.state.app_url+'/images/data_sources/button_icons/trash.svg'"></span>
                            <span v-if="getUserPermissions().delete_connections" @click="accountRefresh($event)" class="refresh"><img class="refresh-icon" :src="$store.state.app_url+'/images/data_sources/button_icons/reload.svg'"></span>
                        </span>
                        <input class='ds-count hidden' v-model="data_source.count" />
                    </div>
                </div>
            </div>
            <div v-if="data_sources === 0" class="no-data-sources hidden">
                <div class="alert alert-warning text-center" role="alert">
                    <span class="alert-link">No Data Sources available!</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                data_sources: [],
                user_id:null
            }
        },
        created() {
            this.user_id = this.$store.getters.getAuthUser.original.id;
            this.fetchServerData();
        },

        updated() {
            $('#data_sources').find('.fa-info-circle.tooltipstered').each(function() {
                $(this).tooltipster('destroy')
            });

            $('#data_sources').find('.fa-info-circle').tooltipster({
                delay: 200,
                animation: 'fade',
                animationDuration: 150,
                interactive: true,
                theme: ['tooltipster-noir', 'tooltipster-noir-customized']
            });
        },

        mounted(){
            $('div.v-spinner').attr('style', '');
            let pattern = /edit/g;
            if(!pattern.test(this.$route.path)){
                window.history.pushState(null, null,window.location.pathname);
            }
        },
        methods:{
            fetchServerData() {
                const vueInstance = this;
                axios.all([
                    axios.get('/api/data_sources')
                ]).then(axios.spread(function(data_sources) {
                    vueInstance.data_sources  = $.isEmptyObject(data_sources.data) ? 0 : data_sources.data;
                    if($('.dsource-message').length){
                        let ds_elem = $('.dsource-message');
                        let types = {'success':'TYPE_SUCCESS', 'already':'TYPE_SUCCESS', 'warning':'TYPE_WARNING', 'error':'TYPE_DANGER'};
                        let type = types[ds_elem.attr('msg_type')];
                        let msg = ds_elem.html();

                        if('success' == ds_elem.attr('msg_type')){
                            let split = msg.split('#');
                            let name_given = split[1];
                            msg = split[0] + '\n\nWe have provided a name for this connection but you can rename it below or rename it later in this page.\n\n';
                            msg += "<div class='name_given' user_id='"+split[2]+"' owner_id='"+split[3]+"' data_source_id='"+split[4]+"' connection_id='"+split[5]+"'>";
                            msg += "<b><span class='name_given'>"+name_given+"</span></b><input class='name_given hidden' type='text' class='form-control'>";
                            msg += '<i class="name_given fa fa-pencil" style="margin-left:1rem; cursor:pointer;" aria-hidden="true"></i>';
                            msg += '<i class="name_given fa fa-check hidden" style="margin-left:1rem; cursor:pointer;" aria-hidden="true"></i></div>';
                            BootstrapDialog.show({
                                message: msg,
                                type:BootstrapDialog.TYPE_SUCCESS,
                                title:'Information',
                                onshown: function(dialogRef){
                                    $('.name_given').off();
                                    $('i.name_given.fa-pencil').click(function(){
                                        var $this = $(this);
                                        var parent = $this.parent();
                                        var val = parent.find('span.name_given').addClass('hidden').text();
                                        parent.find('input.name_given').removeClass('hidden').val(val);
                                        parent.find('i.name_given.fa-check').removeClass('hidden');
                                        $this.addClass('hidden');
                                    });
                                    $('i.name_given.fa-check').click(function(){
                                        var $this = $(this);
                                        var parent = $this.parent();
                                        var val = parent.find('input.name_given').addClass('hidden').val();
                                        parent.find('span.name_given').removeClass('hidden').html(val);
                                        parent.find('i.name_given.fa-pencil').removeClass('hidden');
                                        $this.addClass('hidden');
                                    });
                                },
                                buttons: [{
                                    label: 'Close',
                                    action: function(dialogRef) {
                                        dialogRef.close();
                                    }
                                },{
                                    label: 'Save',
                                    cssClass: 'btn-success',
                                    action: function(dialogRef) {
                                        $('i.name_given.fa-check').is(':visible') && $('i.name_given.fa-check').click();

                                        let data = $('div.name_given');
                                        let name = data.find('span.name_given').text();
                                        let user_id = data.attr('user_id');
                                        let owner_id = data.attr('owner_id');
                                        let data_source_id = data.attr('data_source_id');
                                        let connection_id = data.attr('connection_id');

                                        let params = {name:name, user_id:user_id, owner_id:owner_id, data_source_id:data_source_id, connection_id:connection_id};

                                        if(name != name_given){
                                            $.ajax({
                                                method: 'PUT',
                                                url:'/api/data_sources/name_given_by_user',
                                                data:params,
                                                error(response) {
                                                    vueInstance.notification(response.responseJSON.message, 'TYPE_DANGER');
                                                },
                                                success: function(){
                                                    window.location.reload();
                                                }
                                            });
                                        }

                                        dialogRef.close();
                                    }
                                }]
                            });
                        }
                        else{
                            vueInstance.notification(msg, type);
                        }
                        $('.dsource-message').remove();
                    }
                    $('.no-data-sources').removeClass('hidden');
                }));
            },
            connect(ds_id){
                const vueInstance = this;
                axios.all([
                    axios.get('/api/data_sources/'+ds_id)
                ]).then(axios.spread(function(response) {
                    let auth_url = response.data;
                    history.pushState('', '', window.location.href);
                    window.location.replace(auth_url);
                }));
            },
            view(ds_id, event){
                let view_btn = $(event.target);
                let ancestor = view_btn.closest('.data-source');
                let hide_btn = ancestor.find('button.mask');
                view_btn.addClass('hidden');
                hide_btn.removeClass('hidden');
                ancestor.find('.account-details').slideDown();
                window.history.pushState(null, null,window.location.pathname);
            },
            hide(ds_id, event){
                let hide_btn = $(event.target);
                let ancestor = hide_btn.closest('.data-source');
                let view_btn = ancestor.find('button.view');
                view_btn.removeClass('hidden');
                hide_btn.addClass('hidden');
                ancestor.find('.account-details').slideUp();
                window.history.pushState(null, null,window.location.pathname);
            },
            accountEdit(event){
                let t = $(event.target);
                let account = t.closest('.account');
                let account_wrap = t.closest('.account-wrap');
                let edit = account.find('.account-wrap.edit');
                account_wrap.addClass('hidden');
                edit.removeClass('hidden');
                this.name_given_by_user = edit.find('input').val();
            },
            accountView(event){
                const vueInstance = this;
                let t = $(event.target);
                let account = t.closest('.account');
                let account_wrap = t.closest('.account-wrap');
                let view = account.find('.account-wrap.view');
                let name = account_wrap.find('input').val();
                account_wrap.addClass('hidden');
                view.removeClass('hidden');
                if(vueInstance.name_given_by_user != name){
                    let user_id = account.attr('user_id');
                    let owner_id = account.attr('owner_id');
                    let data_source_id = account.attr('data_source_id');
                    let connection_id = account.attr('connection_id');
                    let params = {name:name, user_id:user_id, owner_id:owner_id, data_source_id:data_source_id, connection_id:connection_id};
                    $.ajax({
                        method: 'PUT',
                        url:'/api/data_sources/name_given_by_user',
                        data:params,
                        error(response) {
                            let input = account_wrap.find('input');
                            input.val(vueInstance.name_given_by_user).get(0).dispatchEvent(new Event('input'));
                            vueInstance.notification(response.responseJSON.message, 'TYPE_DANGER');
                        }
                    });
                }
            },
            accountRemove(event){
                const vueInstance = this;
                let t = $(event.target);
                let account = t.closest('.account');
                let user_id = account.attr('user_id');
                let owner_id = account.attr('owner_id');
                let data_source_id = account.attr('data_source_id');
                let connection_id = account.attr('connection_id');
                let account_name = account.find('input').val();
                let count_input = account.find('input.ds-count');
                let ds_count = count_input.val();
                let params = {user_id:user_id, owner_id:owner_id, data_source_id:data_source_id};
                let message = this.messages.WARNING_DS_ACCOUNT_DELETE;
                this.confirmation(message, function() {
                    $.ajax({
                        method: 'DELETE',
                        url:'/api/data_sources/'+connection_id,
                        data:params,
                        success(response){
                            if(!!response.mate_info){
                                let message = vueInstance.messages.DATA_SOURCES_ACCOUNT_DELETED;
                                message = message.replace("##", account_name);
                                message = message.replace("#", response.mate_info);
                                vueInstance.notification(message, 'type-success', 'INFORMATION', BootstrapDialog.SIZE_SMALL, 5000, function(){location.reload()});
                            }
                            else{
                                let message = vueInstance.messages.DATA_SOURCE_ACCOUNT_DELETED;
                                vueInstance.notification(message.replace("#", account_name));
                            }

                            count_input.val(--ds_count).get(0).dispatchEvent(new Event('input'));

                            account.slideUp(function(){
                                if(ds_count == 0){
                                    let ancestor = t.closest('.data-source');
                                    let view_btn = ancestor.find('button.view');
                                    let hide_btn = ancestor.find('button.mask');
                                    view_btn.removeClass('hidden');
                                    hide_btn.addClass('hidden');
                                    ancestor.find('.account-details').slideUp();
                                    view_btn.prop('disabled', true);
                                }
                            });
                        },
                        error(response) {
                            vueInstance.notification(response.responseJSON.message, 'TYPE_DANGER');
                        }
                    });
                });
            },
            accountRefresh(event){
                const vueInstance = this;
                let t = $(event.target);
                let account = t.closest('.account');
                let user_id = account.attr('user_id');
                let owner_id = account.attr('owner_id');
                let data_source_id = account.attr('data_source_id');
                let connection_id = account.attr('connection_id');
                let params = {user_id:user_id, owner_id:owner_id, data_source_id:data_source_id, connection_id:connection_id};
                $('body').find('.refresh-accounts').removeClass('hidden');
                axios.post('/api/data_sources/refresh', params).then((response) => {
                    $('body').find('.refresh-accounts').addClass('hidden');
                    if(response.data.message == 'success'){
                        vueInstance.notification('Accounts successfully refreshed', 'TYPE_SUCCESS');
                    }
                });
            },
            atLeastOneDataSourceConnected() {
                return _.sum(_.map(this.data_sources, 'count')) > 0;
            },

            browseForDataFile(event) {
                $(event.target).closest('.data-source-actions').find('input[type="file"]').click();
            },

            dataFileChange(dataSourceId, event) {
                const formData = new FormData;
                formData.append('data_file', event.target.files[0]);
                formData.append('_method', 'PUT');

                $(event.target).prev('button').button('loading');

                axios.post(`/api/custom-data-sources/${dataSourceId}`, formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                }).then(() => {
                    this.notification('File has been successfully imported.');
                    this.fetchServerData();

                    $(event.target).prev('button').button('reset');
                });
            },

            getCustomDsEmail(dataSource) {
                return btoa(dataSource.data_source_owner_id + '_' + dataSource.data_source_id) + '@difdash.com';
            }
        }
    }
</script>

<style lang="scss">
    @import '~@/_variables.scss';
    #data_sources {
        .btn-success .simple-svg-wrapper {
            display: inline;
        }

        span.button-wrap{
            .simple-svg {
                top: -0.1rem;
                position: relative;
                margin-right: 0.8rem;
                fill: #8ec24b !important;
            }
            &:hover{
                .simple-svg {
                    fill: white !important;
                }
            }
        }
        .tooltip {
            opacity: 1;

            .tooltip-arrow {
                border-bottom-color: #3b5870;
            }
            .tooltip-inner {
                background: white;
                padding: .8rem;
                color: #58a4c8;
                border: .16rem solid #ddd;
                max-width: 25.6rem;
            }
        }
        .fa-info-circle {
            color: #b2b2b2;
        }
    }
</style>

<style lang="scss" scoped>
    @import '~@/_variables.scss';
    .data-source-wrap{
        font-family: 'BentonSans Regular';
        .data-sources-list {
            overflow: initial ;
        }
        .data-source{
            background-color:#fff;
            &.inactive{
                opacity: .5;
                pointer-events: none;
            }
        }
        .data-source-name img {
            margin-right: 0.8rem;
            max-width: 3.2rem;
        }
        .data-source-accounts{
            font-size:1.3rem;
        }
    }

    .btn-size{
        font-size: 1.12rem;
        font-weight: 500;
    }
    span.button-wrap{
        .btn{
            &.hoverable{
                &.view-button{
                    background-color: transparent;
                    color: #59c998;
                    border-color: #59c998;
                    min-width: 9rem;
                    &:hover {
                        color: 3dffaa;
                        border-color: 3dffaa;
                    }
                    &:active {
                        box-shadow: none;
                        color: 3dffaa;
                        border-color: 3dffaa;
                    }
                    img {
                        top: -0.1rem;
                        right: 0.2rem;
                        position: relative;
                        height: 1.28rem;
                    }
                }
            }
        }
    }
    .account-counter {
        display: inline-block;
        background-color: #f3f3f3;
        border-radius: 50%;
        line-height: 4rem;
        width: 4rem;
        height: 4rem;
    }

    .btn-info .simple-svg-wrapper {
        -moz-user-select: none;
        -webkit-user-select: none;
        user-select: none;
        pointer-events: none;
    }

    .pencil-icon, .trash-icon, .check-icon, .refresh-icon {
        height: 1.6rem;
        &:hover {
            filter: brightness(50%);
        }
    }

    .check-icon {
        height: 1.6rem;
    }

    .account-details{
        .account{
            align-content: flex-start;
            display: inline-flex;
            justify-content: left;
            margin-bottom: 1.6rem;

            color: #b8b8b8;
            @media (min-width: 768px) {
                margin-left: 1.8rem;
            }
            .flex-wrap{
                display:flex;
                .account-name{
                    font-weight: normal;
                    color: #333;
                    font-size: 1.6rem;
                    display: inline-block;
                    text-align: left;
                    :not(:first-child) {
                        margin-left: 1.8rem;
                    }
                }
                span.edit-name{
                    margin-left: 1.6rem;
                    text-align: left;
                    font-size: 1.6rem;
                    padding-top:0.3rem;
                    color: #8b8b8b;
                    cursor:pointer;
                }
                &.edit{
                    input{
                        height: 3rem;
                        border: none;
                        font-size: 1.6rem;
                        border-bottom: 0.1rem solid #848484;
                        /* text-decoration: underline; */
                        font-weight: normal;
                        color: #333;
                    }
                    i{
                        font-size:1.6rem;
                        position: relative;
                        top: 0.4rem;

                    }
                }
            }
            span.remove, span.refresh{
                display: inline-block;
                cursor: pointer;
                color: #8b8b8b;
                margin-left:1.6rem;
                text-align: right;
                padding-top:0.3rem;
                font-size: 1.6rem;
            }
            span.refresh{
                margin-left:1.6rem;
            }
        }
    }
</style>
